import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { ISupplier, HotelSupplierBooking } from "../../../../Supplier"
import { useOutletContext } from "react-router"

export default function HotelBookingSuppliersPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ISupplier
		revalidate: () => void
	}>()
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_HOTEL_SUPPLIERS}>
			<Helmet>
				<title>Hotel Bookings Supplier</title>
			</Helmet>
			<HotelSupplierBooking supplier={transportServiceProvider} />
		</ForbidUnlessAuthorized>
	)
}
